<kd-loader *ngIf="loader" [fixed]="true"></kd-loader>
<kd-navigation *ngIf="ready"></kd-navigation>

<div *ngIf="ready" class="scroll-container" (scroll)="throttledOnScroll()">
    <kd-header></kd-header>

    <div class="route-container">
        <router-outlet></router-outlet>
    </div>
</div>
